import { generateOpenApi } from '@ts-rest/open-api';
import { accessControlContract } from './access-control.contract.js';

export const accessControlOpenApiSpec = generateOpenApi(
  accessControlContract,
  {
    info: {
      title: 'Skewb Works Access Control API',
      version: '1.0.0',
      description:
        'Type-safe access-control (RBAC) API for Skewb Works Lite. Covers effective permissions, the subject registry, role CRUD, and user-role assignment.',
      contact: {
        name: 'Skewb Works Development Team',
      },
    },
    servers: [
      {
        url: 'https://localhost:8080',
        description: 'Local development server',
      },
      {
        url: 'https://api.works-works-lite.dev.skewbdigital.co.uk',
        description: 'Dev API server',
      },
    ],
    tags: [
      {
        name: 'Access Control',
        description: 'Role-based access-control endpoints (permissions, subjects, roles)',
      },
    ],
  },
  {
    setOperationId: true,
    operationMapper: (operation) => ({
      ...operation,
      tags: ['Access Control'],
    }),
  },
);
